interface OfferChevronRightProps {
  width?: string | number;
  height?: string | number;
  color?: string;
}

const OfferChevronRight = ({
  width = "12",
  height = "12",
  color = "#374151",
}: OfferChevronRightProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
  >
    <g clipPath="url(#clip0_offer_chevron)">
      <path
        d="M9.17915 5.52583C9.44028 5.78696 9.44028 6.20922 9.17915 6.46758L3.84535 11.8041C3.58422 12.0653 3.16196 12.0653 2.9036 11.8041C2.64525 11.543 2.64247 11.1208 2.9036 10.8624L7.76514 6.00087L2.90083 1.13656C2.63969 0.875424 2.63969 0.453165 2.90083 0.19481C3.16196 -0.0635461 3.58422 -0.0663241 3.84258 0.19481L9.17915 5.52583Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_offer_chevron">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default OfferChevronRight;
